module.exports = __webpack_public_path__ + "static/media/undraw_sign_in_e6hj.116d4a4b.svg";